<div id="login-page" class="flex flex-row-reverse pin-background">

  <div class="flex flex-col gap-10 items-center w-full h-screen" role="main">
    <div class="flex justify-center lg:hidden">
      <pin-logo [type]="logoType.LOGIN_MOBILE"></pin-logo>
    </div>

    <div class="flex grow flex-col justify-center items-center gap-10 public-container">
      @if (notification !== undefined) {
        <div role="complementary" class="w-full" aria-label="login-notification">
          @switch (notification) {
            @case (notificationEnum.SessionExpired) {
              <pin-notification type="info">
                You have been logged out due to inactivity.
              </pin-notification>
            }

            @case (notificationEnum.TryAgainLater) {
              <pin-notification type="alert">
                This page is currently unavailable. Please try again later.
              </pin-notification>
            }

            @case (notificationEnum.WrongUsernameOrPassword) {
              <pin-notification type="alert">
                Login failed.
              </pin-notification>
            }

            @case (notificationEnum.TooManyLoginAttempts) {
              <pin-notification type="info">
                Too many login attempts. Please try again later, or click "Forgot username or password" to reset your credentials.
              </pin-notification>
            }

            @case (notificationEnum.ForgotPasswordChangeSuccess) {
              <pin-notification type="success">
                Your password was successfully changed. Please log in using your new password.
              </pin-notification>
            }

            @case (notificationEnum.CodeExpired) {
              <pin-notification type="info">
                Code expired. Please log in again.
              </pin-notification>
            }

            @case (notificationEnum.RegistrationNotConfirmed) {
              <pin-notification type="warning">
                To use your DCP account, you still need to confirm the email address by clicking on the confirmation link sent to your email.
                If you did not receive an email after a few minutes you can
                <pin-button buttonStyle="link" buttonId="resendMailLink" customClass="pb-1!" (buttonClick)="resendConfirmationMail()" [isDisabled]="resendingMail">resend the confirmation email.</pin-button>
              </pin-notification>
            }

            @case (notificationEnum.ResendConfirmationMailSuccess) {
              <pin-notification type="success">
                You have successfully resent the confirmation email. Please check your email.
              </pin-notification>
            }
            @case (notificationEnum.LimitExceededException) {
              <pin-notification type="alert">
                Too many attempts. Please try again later.
              </pin-notification>
            }
            @case (notificationEnum.UserProfilePasswordChangeSuccess) {
              <pin-notification type="info">
                  Your password has been successfully changed. For your security, we've logged you out. Please log in again with your new password to continue.
              </pin-notification>
            }

            @case (notificationEnum.UsernameRemediationSuccess) {
              <pin-notification type="success">
                Your username was successfully changed. Please log in using your new username.
              </pin-notification>
            }
          }
        </div>
      }

      <div class="login-content w-full">

        <form [formGroup]="loginForm" (ngSubmit)="login()" class="flex flex-col gap-6">
          <div class="flex flex-col gap-2">
            <h1 class="dcp-h1">Log In</h1>

            <p class="dcp-body" data-testid="login-description">
              If you have already verified your account, log in here.
            </p>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col">
              <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" formControlName="username" i18n-placeholder="@@username-placeholder">
                <mat-error i18n="@@login.error.username.required">Username is <strong>required</strong></mat-error>
              </mat-form-field>

              <div class="flex flex-row justify-between items-center">
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>Password</mat-label>
                  <pin-password-input formControlName="password"></pin-password-input>
                  <mat-error i18n="@@login.error.password.required">Password is <strong>required</strong></mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-col gap-10">
              <p class="dcp-body forgot-credentials">
                Forgot
                <pin-button buttonStyle="link" customClass="pb-1!" buttonId="forgot-username-link" [buttonType]="buttonType.DEFAULT" redirectUrl="/forgot-username"> username </pin-button>
                or
                <pin-button buttonStyle="link" customClass="pb-1!" buttonId="forgot-password-link" [buttonType]="buttonType.DEFAULT" redirectUrl="/forgot-password"> password </pin-button>
                ?
              </p>
              <pin-button buttonId="login-button" [isDisabled]="loginForm.invalid || isLoading" buttonStyle="filled">LOG IN</pin-button>
            </div>
          </div>

        </form>
      </div>
    </div>

    <pin-registration-side customClass="registration-side-mobile" class="w-full lg:hidden"></pin-registration-side>

    <pin-footer type="login" customClass="bg-transparent!"></pin-footer>
  </div>

  <pin-registration-side customClass="registration-side-desktop" class="hidden lg:block"></pin-registration-side>
</div>

@if (isLoading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
